import {FC, memo} from "react";
import {ComplectationsSectionProps} from "./AccessoriesSection-types";
import {Body, Head, Root, Title} from "./AccessoriesSection-styles";
import SectionVariants from "../SectionVariants/SectionVariants";
import {useOptionsByAttribute} from "../../hooks/useOptionsByAttribute";
import {generateUid} from "../../utils/ApplicationUtils";


const AccessoriesSection: FC<ComplectationsSectionProps> = memo((props) => {
    const {accessoire, onOptionSelect} = props;
    const uid = generateUid(accessoire.id, accessoire.attributes[0].id);

    const options = useOptionsByAttribute(accessoire.items, accessoire.attributes[0].id);

    return (
        <Root>
            <Head>
                <Title>{accessoire.title}</Title>
            </Head>

            <Body>
                <SectionVariants uid={uid} options={options} onOptionSelect={onOptionSelect}/>
            </Body>
        </Root>
    );
});

export default AccessoriesSection;
